import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import GlobalHeader from '../components/layout/GlobalHeader';
import { useAuth } from '../context/AuthContext';

const MainLayout = () => {
    const { isAuthenticated } = useAuth();
    const location = useLocation();

    if (!isAuthenticated) {
        return <Outlet />;
    }

    const isAppSection = location.pathname.startsWith('/app/cotizaplus') || location.pathname.startsWith('/app/crm') || location.pathname.startsWith('/app/inventario');
    const isGlobalContext = !isAppSection;

    return (
        <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa', display: 'flex', flexDirection: 'column', position: 'relative' }}>
            {/* Fondo animado solo para el layout global (Mis Aplicaciones) */}
            {isGlobalContext && (
                <div className="visual-placeholder" style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', overflow: 'hidden', zIndex: 0, pointerEvents: 'none' }}>
                    <div className="floating-circle circle-1" style={{ top: '10%', right: '10%', opacity: 0.3 }}></div>
                    <div className="floating-circle circle-2" style={{ bottom: '20%', left: '10%', opacity: 0.3 }}></div>
                </div>
            )}

            <div style={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', flex: 1 }}>
                <GlobalHeader />
                <div style={{ flex: 1, display: 'flex', overflow: 'hidden', zIndex: 1, width: '100%', maxWidth: '100vw' }}>
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

export default MainLayout;
